<template>
  <div class="networkshops">
    <page-header title="Доставка в торговые сети" title-in-breadcrumbs="Доставка в сети" />
    <div class="public-container">
      <networkshops-about />
      <div class="public-container-mobile my-110">
        <h2 class="vz-text-align-left">
          Рассчитать доставку груза
        </h2>
        <vz-calculator is-network />
        <div>
          <h3 class="text-h1 mt-40 mb-20">
            Сети, у которых доступен бесплатный простой машины в рамках "окна доставки"
          </h3>
          <ul class="public-list public-list-square networkshops-with-timetable">
            <li v-for="text of networkList">
              <nuxt-link 
                v-if="['ВАЙЛДБЕРРИЗ ООО', 'OZON (Интернет решения)'].includes(text)" 
                :to="text === 'ВАЙЛДБЕРРИЗ ООО' ? '/wildberries/' : '/ozon/'"
                class="text-decoration-underline"
                target="_blank"
              > 
                {{ text }}
              </nuxt-link>
              <span v-else>
                {{ text }}
              </span>
            </li>
          </ul>
        </div>
      </div>
      <networkshops-requirements 
        requirements-type="networkshops"
      />
      <div class="public-container-mobile">
        <networkshops-services />
        <networkshops-additional-services />
        <networkshops-scheme />
        <public-markets-list :list="networkShopsList" title="Торговые сети, куда мы доставляем товары:"  class="my-90" />
        <networkshops-movement />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import PageHeader from '~/components/public/page-header.vue'
import {getPageContent} from '~/api/content';
import VzCalculator from '~/components/public/order/vz-calculator.vue';
import NetworkshopsAbout from '~/components/public/networkshops/networkshops-about.vue';
import NetworkshopsMovement from '~/components/public/networkshops/networkshops-movement.vue';
import NetworkshopsRequirements from '~/components/public/networkshops/networkshops-requirements.vue';
import NetworkshopsServices from '~/components/public/networkshops/networkshops-services.vue';
import NetworkshopsAdditionalServices from '~/components/public/networkshops/networkshops-additional-services.vue';
import NetworkshopsScheme from '~/components/public/networkshops/networkshops-scheme.vue';
import PublicMarketsList from '~/components/public/public-markets-list.vue'
import {asyncComputed} from '@vueuse/core';
import {networkShopsList} from '~/common/public/markets'
import {getTradingNetworkList} from '~/api/trading-network';

const content = await getPageContent('/networkshops')

const networkList = asyncComputed(async () => {
  const list = await getTradingNetworkList({ filialOptionalInfo: '1' })
  return list
    .filter(t => t.filialOptionalInfo?.hasTimetable)
    .map(t => t.name)
}, [])
</script>

<style lang="scss" scoped>
.networkshops-with-timetable {
  column-count: 3;
  @media screen and (max-width: $md) {
    column-count: 2;
  }
  @media screen and (max-width: $sm) {
    column-count: 1;
  }
}
</style>
